import { FC, ReactElement } from 'react';

import { useHirePlanFormStepStore } from '../../../stores/useHirePlanFormStepStore';
import { useWindowSizeStore } from '../../../stores/useWindowSizeStore';
import { Button } from '../../Button';
import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon';
import { ArrowRightIcon } from '../../icons/ArrowRightIcon';

export interface GoForwardButtonBaseProps {
  addBackButton?: boolean;
  isMobile?: boolean;
  onForwardClick?: () => void;
  mobileText?: string;
  disabled?: boolean;
  desktopText?: string;
  Icon?: FC;
  validate?: () => boolean;
  type?: 'button' | 'reset' | 'submit';
  containerClassName?: string;
  buttonClassName?: string;
}

export function GoForwardButtonBase({
  addBackButton = false,
  isMobile,
  onForwardClick,
  disabled = false,
  mobileText = 'Avançar',
  desktopText = 'Continuar',
  Icon,
  validate,
  type = 'button',
  containerClassName = 'w-full min-[748px]:mt-4 mt-24 relative flex min-[748px]:justify-end justify-center gap-6',
  buttonClassName = 'max-[748px]:max-w-[262px] max-[748px]:w-full',
}: GoForwardButtonBaseProps): ReactElement {
  const width = useWindowSizeStore(state => state.width);
  const goToPreviousStep = useHirePlanFormStepStore(
    state => state.goToPreviousStep,
  );

  const mobile = isMobile ?? width < 748;

  const handleForwardClick = () => {
    if (validate && !validate()) {
      return;
    }

    onForwardClick?.();
  };

  return (
    <div className={containerClassName}>
      {!mobile && addBackButton && (
        <Button
          text="Voltar"
          Icon={ArrowLeftIcon}
          intent="secondary"
          onClick={goToPreviousStep}
        />
      )}
      <Button
        disabled={disabled}
        type={type}
        onClick={handleForwardClick}
        text={mobile ? mobileText : desktopText}
        Icon={Icon ?? (mobile ? undefined : ArrowRightIcon)}
        className={buttonClassName}
      />
    </div>
  );
}
